module.exports = __webpack_public_path__ + "media/tr_tr_s3_Muhammed.696defcd.mp3";